import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
// 得意先选中类型
export var SelectedTypes = {
  Selected: 0,
  // '勾选得意先',
  CurrentPage: 1,
  // '当前页',
  AllPage: 2 // '全部页'
};

/**
 * 得意先列表相关操作
 */
export default {
  methods: {
    /**
     * 单个删除/批量删除得意先
     *
     * 使用页面:
     * - 添加/编辑到货通知页面 src/pages/productmanager/arrivalNotice/addNotice.vue
     * @param record 当前行数据
     */
    removeErpCustomers: function removeErpCustomers(record) {
      var _this = this;
      //判断是 选择的值，还是 当前页，还是全部页
      var lodingData = [];
      if (record) {
        lodingData = [record];
      } else {
        if (this.modalValue.removeType === SelectedTypes.Selected) {
          // 选中的得意先
          lodingData = _.cloneDeep(this.selectCustomerList);
        } else if (this.modalValue.removeType === SelectedTypes.CurrentPage) {
          // 当前页面的得意先
          lodingData = _.cloneDeep(this.crrentPageProductList);
        } else {
          // 全部得意先
          lodingData = _.cloneDeep(this.dyxList);
        }
      }
      // 到货通知的删除需要排除已经通知过的得意先
      if (this.handleCustomerList) {
        lodingData = this.handleCustomerList(lodingData);
      }
      //移除
      lodingData.forEach(function (item) {
        _this.dyxList = _.remove(_this.dyxList, function (o) {
          return o.erpCustomerId !== item.erpCustomerId;
        });
        _this.selectCustomerList = _.remove(_this.selectCustomerList, function (o) {
          return o.erpCustomerId !== item.erpCustomerId;
        });
        _this.selectedRowKeys = _.remove(_this.selectedRowKeys, function (o) {
          return o !== item.erpCustomerId;
        });
      });

      //移除过以后需要重新 获取一下当前页，要不然无法连续移除
      var newlist = _.cloneDeep(this.dyxList);
      this.crrentPageProductList = newlist.splice((this.queryParam.page - 1) * this.queryParam.size, this.queryParam.size);
      this.alreadySelect = this.dyxList.map(function (item) {
        return item.erpCustomerId;
      });
      //如果商品list为 0 那么需要把分页的页码重置
      if (this.dyxList.length === 0) {
        this.queryParam.page = 1;
      }
      this.listTotal = this.dyxList.length;
      this.selectNumber = this.selectCustomerList.length;
      this.removeTypeVisible = false;
    }
  }
};